import createIcon from '../../createIcon';

/**
 * @component @name Title
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA0LjVWNy41SDEwLjVWMTkuNUgxMy41VjcuNUgxOVY0LjVINVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Title = createIcon('Title', [
  ['path', { d: 'M5 4.5V7.5H10.5V19.5H13.5V7.5H19V4.5H5Z', key: '1l5tpz' }],
]);

export default Title;
